import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

// Components
import {
  BackgroundContainer,
  AbsolutePositioned
} from '../../../components/Layout/AbsolutePositioned';
import { ContentContainer } from '../../../components/Layout/ContentContainer';
import { Screen, SplitScreen } from '../../../components/Layout/Screen';
import Title, { Highlight } from '../../../components/Title';
import TextBlock from '../../../components/TextBlock';
import LineLink from '../../../components/LineLink';

// Assets
import { brandColors, device } from '../../../styles/variables';
import team from '../../../assets/images/RD_Team_image_3_edited_colour.jpg';

const StyledScreen = Screen.extend`
  background: url(${team});
  background-size: cover;
  background-position: top;
`;

const BackgroundSplitScreen = SplitScreen.extend`
  height: 100%;
`;

const ContentHolder = AbsolutePositioned.extend`
  width: 100%;
  height: 100%;
`;

const TitleContainer = styled.div`
  margin: 30px 0 0 0;
  @media ${device.tablet} {
    margin: 215px 0 0 0;
  }
  @media ${device.laptop} {
    margin: 107px 0 0 0;
  }
`;

const ContentSplitScreen = SplitScreen.extend`
  vertical-align: top;
  position: relative;
  display: block;
  width: 100%;
  @media ${device.tablet} {
    display: inline-block;
    width: 50%;
  }

  .featureLineLinks {
    position: relative;
    width: 100%;
    pointer-events: all;
    max-width: 44%;
    float: right;
    @media ${device.tablet} {
      max-width: 80%;
      margin: 0 auto;
      float: none;
    }
  }
`;

const FooterScreen = () => (
  <StyledScreen>
    <BackgroundContainer>
      <BackgroundSplitScreen background={brandColors.blue} opacity="0.8" />
      <BackgroundSplitScreen background={brandColors.lightblue} opacity="0.8" />
    </BackgroundContainer>
    <ContentHolder>
      <ContentContainer>
        <TitleContainer>
          <Title color={brandColors.white}>
            Talented people, <Highlight>great</Highlight> team
          </Title>
        </TitleContainer>
        <ContentSplitScreen>
          <TextBlock color={brandColors.white} width="300px">
            <p>
              As a group of scientific, technical and creative folk, we thrive on the diversity of
              projects we work on.
            </p>
            <p>
              Oh, and did we mention we&apos;re only 3 minutes away from the world famous Kew
              Gardens?
            </p>
          </TextBlock>
        </ContentSplitScreen>
        <ContentSplitScreen>
          <LineLink
            className="featureLineLinks"
            subtitle="contact us"
            linkText="work with us"
            linkColor={brandColors.yellow}
            route="/contact#joinUs"
            lineAnimate
            active
          />
        </ContentSplitScreen>
      </ContentContainer>
    </ContentHolder>
  </StyledScreen>
);

export default connect()(FooterScreen);



// WEBPACK FOOTER //
// ./src/pages/About/screens/Footer.jsx